frappe.provide('shipping');

shipping.checkout = {
    initialized: false,
    calculating: false,
    debounceTimeout: null,
    lastPostalCode: null,
    updating_cart: false,
    cart_update_queue: [],
    currentRates: null,
    selectedRateIndex: 0,
    isApplyingShipping: false,

    init: function() {
        if (this.initialized) return;

        var path = window.location && window.location.pathname ? window.location.pathname : "";

        if (path === "/cart" || path.indexOf("/orders") === 0) {
            this.initialized = true;
            return;
        }

        this.initialized = true;
        this.setup_shipping_calculator();
        this.bind_events();
    },

    enable_place_order_button: function() {
        const $btn = $('.cart-container .btn-place-order, .place-order .btn-place-order');
  
        if ($btn.length === 0) {
            return;
        }
  
        $btn.prop('disabled', false)
            .removeClass('disabled')
            .css({
                'pointer-events': 'auto',
                'opacity': '1',
                'cursor': 'pointer'
            });
  
        $btn.off('click.shipping-fallback').on('click.shipping-fallback', function(e) {
            if ($btn.prop('disabled')) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
  
            if (typeof shopping_cart === 'undefined') {
                e.preventDefault();
                e.stopPropagation();
  
                frappe.call({
                    type: "POST",
                    method: "tos_webcommerce.api.checkout.place_order",
                    btn: this,
                    freeze: true,
                    freeze_message: __("Placing Order..."),
                    callback: function(r) {
                        if(r.exc) {
                            var msg = "";
                            if(r._server_messages) {
                                msg = JSON.parse(r._server_messages || []).join("<br>");
                            }
                            $("#cart-error")
                                .empty()
                                .html(msg || frappe._("Something went wrong!"))
                                .toggle(true);
                        } else {
                            $(this).hide();
                            window.location.href = '/orders/' + encodeURIComponent(r.message);
                        }
                    }
                });
            }
        });
    },

    setup_shipping_calculator: function() {
        if (!$('.cart-container').length && !$('#shipping-calculator').length) {
            return;
        }

        if ($('#shipping-calculator').length) {
            const postalCode = this.get_postal_code();
            const shippingAddress = this.get_selected_shipping_address();

            if (postalCode) {
                this.calculate_shipping_by_postal_code(postalCode);
            } else if (shippingAddress) {
                this.get_address_postal_code(shippingAddress);
            }
            return;
        }

        if (!$('.cart-container').length && !$('.cart-items').length) {
            return;
        }

        this.add_shipping_section();

        const postalCode = this.get_postal_code();
        if (postalCode) {
            this.calculate_shipping_by_postal_code(postalCode);
        }
    },

    add_shipping_section: function() {
        if ($('#shipping-calculator').length) return;

        const html = `
            <div class="shipping-section mt-4 mb-4" id="shipping-calculator">
                <h4><i class="fa fa-truck"></i> Select Shipping Method</h4>
                <div id="shipping-loading" class="text-center" style="display:none;">
                    <i class="fa fa-spinner fa-spin fa-2x"></i>
                    <p class="mt-2">Calculating shipping options...</p>
                </div>
                <div id="shipping-rates" class="shipping-rates-container"></div>
                <div id="shipping-error" class="alert alert-danger" style="display:none;"></div>
            </div>
        `;

        if ($('.cart-addresses').length) {
            $('.cart-addresses').after(html);
        } else if ($('.cart-container').length) {
            $(html).insertBefore('.cart-container .place-order-btn');
        } else if ($('.cart-items').length) {
            $('.cart-items').after(html);
        } else {
            $('.cart-summary, .cart-totals').first().prepend(html);
        }
    },

    get_selected_shipping_address: function() {
        const addressName = $('[data-section="shipping-address"] [data-address-name][data-active]').attr('data-address-name');
        return addressName || null;
    },

    bind_events: function() {
        const self = this;

        $(document).on('click', '[data-section="shipping-address"] .address-card', function() {
            const addressName = $(this).closest('[data-address-name]').attr('data-address-name');
            if (addressName) {
                setTimeout(() => {
                    self.get_address_postal_code(addressName);
                }, 300);
            }
        });

        $(document).on('change', 'select[data-fieldname="shipping_address_name"], input[name="shipping_address"]', function() {
            const address = $(this).val();
            if (address) {
                self.get_address_postal_code(address);
            }
        });

        $(document).on('blur change', 'input[data-fieldname="pincode"], input[name="postal_code"], #postal_code', function() {
            const postalCode = $(this).val();
            if (postalCode && postalCode.length >= 5) {
                self.calculate_shipping_by_postal_code(postalCode);
            }
        });

        $(document).on('cart_updated', function() {
            if (self.isApplyingShipping) {
                return;
            }
            let postalCode = self.get_postal_code();
            if (!postalCode) {
                postalCode = self.lastPostalCode;
            }
            if (postalCode) {
                self.lastPostalCode = null;
                self.currentRates = null;
                setTimeout(() => {
                    self.calculate_shipping_by_postal_code(postalCode, true);
                }, 300);
            }
        });
    },

    get_postal_code: function() {
        const selectors = [
            'input[data-fieldname="pincode"]',
            'input[name="postal_code"]',
            '#postal_code',
            '.pincode-input'
        ];

        for (let selector of selectors) {
            const value = $(selector).val();
            if (value) return value;
        }

        return null;
    },

    get_address_postal_code: function(addressName) {
        frappe.call({
            method: 'tos_webcommerce.api.shipping.get_shipping_address_postal_code',
            args: { address_name: addressName },
            callback: (r) => {
                if (r.message) {
                    this.calculate_shipping_by_postal_code(r.message);
                } else {
                    this.show_error('Please add postal code to your shipping address');
                }
            }
        });
    },

    calculate_shipping_by_postal_code: function(postalCode, forceRecalc = false) {
        const self = this;


        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }

        if (!postalCode) {
            this.show_error('Postal code is required');
            return;
        }

        postalCode = postalCode.toString().replace(/\D/g, '');

        if (postalCode.length < 5) {
            this.show_error('Please enter a valid 5-digit postal code');
            return;
        }

        if (this.calculating) {
            return;
        }

        if (!forceRecalc && this.lastPostalCode === postalCode) {
            return;
        }

        this.debounceTimeout = setTimeout(() => {
            self.make_shipping_api_call(postalCode);
        }, 500);
    },

    make_shipping_api_call: function(postalCode) {

        if (this.calculating) {
            return;
        }

        this.calculating = true;
        this.lastPostalCode = postalCode;


        $('#shipping-loading').show();
        $('#shipping-rates').html('');
        $('#shipping-error').hide();

        frappe.call({
            method: 'tos_webcommerce.api.shipping.get_cart_shipping_rates',
            args: {
                destination_postal_code: parseInt(postalCode)
            },
            callback: (r) => {
                this.calculating = false;
                $('#shipping-loading').hide();

                if (r.message && r.message.success) {
                    this.display_rates(r.message.rates);
                } else {
                    this.show_error(r.message?.message || 'Unable to calculate shipping rates');
                }
            },
            error: (r) => {
                this.calculating = false;
                $('#shipping-loading').hide();
                console.error('Shipping API Error:', r);
                this.show_error('Error calculating shipping rates. Please try again.');
            }
        });
    },

    display_rates: function(rates, preserveSelection = false) {
        if (!rates || rates.length === 0) {
            this.show_error('No shipping options available for your location');
            return;
        }

        this.currentRates = rates;

        $('#shipping-empty').hide();

        if (!preserveSelection && rates.length > 0) {
            this.selectedRateIndex = 0;
            this.apply_shipping(rates[0]);
        }

        this.show_selected_shipping();

        this.enable_place_order_button();
        this.refresh_cart_display();
    },

    show_selected_shipping: function() {
        if (!this.currentRates || this.currentRates.length === 0) {
            return;
        }

        if (this.selectedRateIndex >= this.currentRates.length) {
            this.selectedRateIndex = 0;
        }

        const selectedRate = this.currentRates[this.selectedRateIndex];
        if (!selectedRate) {
            return;
        }

        const duration = selectedRate.min_day && selectedRate.max_day
            ? `${selectedRate.min_day}-${selectedRate.max_day} days`
            : selectedRate.duration || 'N/A';

        const html = `
            <div class="selected-shipping-display" style="border: 1px solid #e0e0e0; border-radius: 6px; padding: 12px; background: #f8f9fa;">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <div style="flex: 1;">
                        <div style="font-weight: 600; font-size: 0.9em; margin-bottom: 4px;">
                            ${selectedRate.courier_name || selectedRate.courier_code.toUpperCase()}
                        </div>
                        <div style="font-size: 0.8em; color: #6c757d; margin-bottom: 2px;">
                            ${selectedRate.courier_service_name}
                        </div>
                        <div style="font-size: 0.75em; color: #6c757d;">
                            <i class="fa fa-clock-o"></i> ${duration}
                        </div>
                    </div>
                    <div style="text-align: right;">
                        <div style="color: #28a745; font-weight: 600; font-size: 0.95em; margin-bottom: 6px;">
                            Rp ${this.format_currency(selectedRate.price)}
                        </div>
                        <button class="btn btn-sm btn-outline-primary" id="btn-change-shipping" style="font-size: 0.75em; padding: 4px 12px;">
                            <i class="fa fa-edit"></i> Change
                        </button>
                    </div>
                </div>
            </div>
        `;

        $('#shipping-rates').html(html);
        this.bind_change_button();

        this.enable_place_order_button();
    },

    bind_change_button: function() {
        const self = this;
        $('#btn-change-shipping').off('click').on('click', function(e) {
            e.preventDefault();
            self.open_shipping_dialog();
        });
    },

    open_shipping_dialog: function() {
        const self = this;

        if (!this.currentRates || this.currentRates.length === 0) {
            frappe.msgprint('No shipping options available');
            return;
        }

        let dialogHtml = '<div class="shipping-options-list">';

        const esc = window.webcommerceEscapeHtml || (s => s);

        this.currentRates.forEach((rate, index) => {
            const isSelected = index === this.selectedRateIndex;
            const duration = rate.min_day && rate.max_day
                ? `${esc(String(rate.min_day))}-${esc(String(rate.max_day))} days`
                : esc(rate.duration || 'N/A');

            dialogHtml += `
                <div class="shipping-option-item ${isSelected ? 'selected' : ''}" data-index="${index}"
                     style="border: 2px solid ${isSelected ? '#007bff' : '#e0e0e0'};
                            border-radius: 6px;
                            padding: 12px;
                            margin-bottom: 10px;
                            cursor: pointer;
                            background: ${isSelected ? '#e7f3ff' : '#fff'};
                            transition: all 0.2s;">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <div style="flex: 1;">
                            <div style="font-weight: 600; font-size: 1em; margin-bottom: 4px;">
                                ${isSelected ? '<i class="fa fa-check-circle text-primary"></i> ' : ''}
                                ${esc(rate.courier_name || (rate.courier_code || '').toUpperCase())}
                            </div>
                            <div style="font-size: 0.85em; color: #6c757d; margin-bottom: 2px;">
                                ${esc(rate.courier_service_name)}
                            </div>
                            <div style="font-size: 0.8em; color: #6c757d;">
                                <i class="fa fa-clock-o"></i> Estimate: ${duration}
                            </div>
                        </div>
                        <div style="text-align: right;">
                            <strong style="color: #28a745; font-size: 1.1em;">
                                Rp ${this.format_currency(rate.price)}
                            </strong>
                        </div>
                    </div>
                </div>
            `;
        });

        dialogHtml += '</div>';

        const dialog = new frappe.ui.Dialog({
            title: '<i class="fa fa-truck"></i> Select Shipping Method',
            fields: [
                {
                    fieldtype: 'HTML',
                    fieldname: 'shipping_options',
                    options: dialogHtml
                }
            ],
            size: 'large',
            primary_action_label: 'Close',
            primary_action: function() {
                dialog.hide();
            }
        });

        dialog.show();

        dialog.$wrapper.find('.shipping-option-item').on('click', function() {
            const selectedIndex = parseInt($(this).data('index'));
            const selectedRate = self.currentRates[selectedIndex];

            self.selectedRateIndex = selectedIndex;

            self.apply_shipping(selectedRate);

            dialog.$wrapper.find('.shipping-option-item').each(function(idx) {
                const isSelected = idx === selectedIndex;
                $(this).css({
                    'border-color': isSelected ? '#007bff' : '#e0e0e0',
                    'background': isSelected ? '#e7f3ff' : '#fff'
                }).toggleClass('selected', isSelected);

                const iconHtml = isSelected ? '<i class="fa fa-check-circle text-primary"></i> ' : '';
                $(this).find('div:first > div:first').html(
                    iconHtml + (selectedRate.courier_name || selectedRate.courier_code.toUpperCase())
                );
            });

            self.show_selected_shipping();

            setTimeout(() => {
                dialog.hide();
            }, 500);
        });

        dialog.$wrapper.find('.shipping-option-item').on('mouseenter', function() {
            if (!$(this).hasClass('selected')) {
                $(this).css('background', '#f8f9fa');
            }
        }).on('mouseleave', function() {
            if (!$(this).hasClass('selected')) {
                $(this).css('background', '#fff');
            }
        });
    },


    apply_shipping: function(rate, retryCount = 0) {
        const self = this;
        const maxRetries = 3;

        this.isApplyingShipping = true;

        frappe.call({
            method: 'tos_webcommerce.api.shipping.apply_shipping_to_cart',
            args: {
                courier_code: rate.courier_code,
                courier_service_code: rate.courier_service_code,
                shipping_cost: rate.price
            },
            callback: (r) => {
                self.isApplyingShipping = false;

                if (r.message && r.message.success) {
                    const courierName = rate.courier_name || rate.courier_code.toUpperCase();
                    const serviceName = rate.courier_service_name || rate.courier_service_code.toUpperCase();
                    const shippingCost = rate.price;

                    frappe.show_alert({
                        message: `${courierName} - ${serviceName} - Rp ${self.format_currency(shippingCost)} applied`,
                        indicator: 'green'
                    }, 3);

                    frappe.call({
                        method: 'webshop.webshop.shopping_cart.cart.get_cart_quotation',
                        freeze: false,
                        callback: (cart_r) => {
                            if (cart_r.message && cart_r.message.doc) {
                                self.update_payment_summary_display(cart_r.message.doc);

                                setTimeout(() => {
                                    self.show_selected_shipping();
                                }, 100);
                            }
                        }
                    });

                    self.enable_place_order_button();
                }
            },
            error: (r) => {
                self.isApplyingShipping = false;

                if (r.message && r.message.includes('Document has been modified')) {
                    if (retryCount < maxRetries) {
                        setTimeout(() => {
                            self.apply_shipping(rate, retryCount + 1);
                        }, 1000 * (retryCount + 1)); 
                        return;
                    }
                }

                console.error('Failed to apply shipping:', r);
                frappe.show_alert({
                    message: 'Failed to apply shipping. Please try again.',
                    indicator: 'red'
                }, 5);
            }
        });
    },

    update_payment_summary_only: function() {
        const self = this;
        frappe.call({
            method: 'webshop.webshop.shopping_cart.cart.get_cart_quotation',
            freeze: false,
            callback: (r) => {
                if (r.message && r.message.doc) {
                    const quotation = r.message.doc;
                    self.update_payment_summary_display(quotation);
                }
            }
        });
    },

    format_currency: function(amount) {
        return new Intl.NumberFormat('id-ID').format(amount);
    },

    show_error: function(message) {
        $('#shipping-loading').hide();
        $('#shipping-rates').html('');
        $('#shipping-error').html(message).show();

        $('.place-order-btn').prop('disabled', false).removeClass('disabled');

    },

    skip_shipping: function() {
        frappe.show_alert({
            message: 'Proceeding without automatic shipping calculation',
            indicator: 'orange'
        }, 3);

        $('#shipping-calculator').hide();

        $('.place-order-btn').prop('disabled', false).removeClass('disabled');
        $(document).trigger('cart_updated');
    },

    queue_cart_refresh: function() {
        if (this.updating_cart) {
            this.cart_update_queue.push(Date.now());
            return;
        }

        this.refresh_cart_display();
    },

    refresh_cart_display: function() {
        if (this.updating_cart) {
            return;
        }

        this.updating_cart = true;

        frappe.call({
            method: 'webshop.webshop.shopping_cart.cart.get_cart_quotation',
            callback: (r) => {
                this.updating_cart = false;

                if (r.message && r.message.doc && !r.exc) {
                    const quotation = r.message.doc;

                    this.update_payment_summary_display(quotation);

                    $(document).trigger('cart_updated');
                    $(document).trigger('shipping_applied');

                    this.process_cart_update_queue();
                } else {
                    this.refresh_cart_totals();
                }
            },
            error: () => {
                this.updating_cart = false;
                this.refresh_cart_totals();
            }
        });
    },

    process_cart_update_queue: function() {
        if (this.cart_update_queue.length > 0) {
            this.cart_update_queue = [];
            setTimeout(() => {
                this.refresh_cart_totals();
            }, 500);
        }
    },

    refresh_cart_totals: function() {
        frappe.call({
            method: 'webshop.webshop.shopping_cart.cart.get_cart_quotation',
            callback: (r) => {
                if (r.message && r.message.doc) {
                    const quotation = r.message.doc;

                    this.update_payment_summary_display(quotation);

                    $(document).trigger('cart_updated');
                    $(document).trigger('shipping_applied');
                }
            }
        });
    },

    update_payment_summary_display: function(quotation) {

        let shippingTax = null;
        if (quotation.taxes) {
            shippingTax = quotation.taxes.find(tax =>
                tax.account_head && tax.account_head.toLowerCase().includes('shipping')
            );
        }

        if (shippingTax) {
            const formattedCost = `Rp ${this.format_currency(shippingTax.tax_amount)}`;
            const description = shippingTax.description || 'Shipping';


            $('.payment-summary table tr').each(function() {
                const $row = $(this);
                const $label = $row.find('.bill-label');

                if ($label.length && $label.text().toLowerCase().includes('shipping')) {
                    $label.text(description);

                    const $amount = $row.find('.bill-content.text-right');
                    if ($amount.length) {
                        $amount.text(formattedCost);
                    }
                }
            });
        }

        if (quotation.grand_total) {
            const formattedTotal = `Rp ${this.format_currency(quotation.grand_total)}`;

            $('.payment-summary .grand-total tr').each(function() {
                const $row = $(this);
                const $totalLabel = $row.find('.bill-content.net-total').first();

                if ($totalLabel.length && $totalLabel.text().toLowerCase().includes('grand total')) {
                    $row.find('.bill-content.net-total.text-right').text(formattedTotal);
                }
            });
        }
    },

    fallback_refresh_cart: function() {
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    }
};

shipping.safeInit = function() {
    try {
        shipping.checkout.init();
    } catch (e) {
        console.error('Shipping initialization error:', e);
    }
};

$(document).ready(function() {
    shipping.safeInit();

});

frappe.ready(function() {
    shipping.safeInit();

});

$(document).on('page-change', function() {
    setTimeout(function() {
        shipping.checkout.initialized = false;
        shipping.safeInit();
    }, 500);
});

if (typeof biteship === 'undefined') {
    window.biteship = shipping;
}
